/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc
 */
import * as References from './ApplicationsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getAppComponentIndexByAppId
 */
export const GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getAppComponentIndexByAppId';
export const GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY: RegisteredQuery<
  'result',
  References.GetAppComponentIndexByAppIdRequestType,
  References.GetAppComponentIndexByAppIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY_FIELD_NAME,
  args: ['applicationId', 'appId'],
  fetcher(
    request: References.GetAppComponentIndexByAppIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppComponentIndexByAppIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppComponentIndexByAppIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getApplicationsForPortal
 */
export const GET_APPLICATIONS_FOR_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getApplicationsForPortal';
export const GET_APPLICATIONS_FOR_PORTAL_QUERY: RegisteredQuery<
  'result',
  References.GetApplicationsForPortalRequestType,
  References.GetApplicationsForPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPLICATIONS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['appFilters', 'applicationRequestExtras'],
  fetcher(
    request: References.GetApplicationsForPortalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApplicationsForPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApplicationsForPortalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getApplicationsByProjectAndPortal
 */
export const GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getApplicationsByProjectAndPortal';
export const GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY: RegisteredQuery<
  'result',
  References.GetApplicationsByProjectAndPortalRequestType,
  References.GetApplicationsByProjectAndPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY_FIELD_NAME,
  args: ['projectName', 'requestExtras'],
  fetcher(
    request: References.GetApplicationsByProjectAndPortalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetApplicationsByProjectAndPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getApplicationsByProjectAndPortalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getByClientId
 */
export const GET_BY_CLIENT_ID_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getByClientId';
export const GET_BY_CLIENT_ID_QUERY: RegisteredQuery<
  'result',
  References.GetByClientIdRequestType,
  References.GetByClientIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_CLIENT_ID_QUERY_FIELD_NAME,
  args: ['clientId', 'applicationRequestExtras'],
  fetcher(
    request: References.GetByClientIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByClientIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByClientIdRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getById';
export const GET_BY_ID_QUERY: RegisteredQuery<
  'result',
  References.GetByIdRequestType,
  References.GetByIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['appId', 'applicationRequestExtras'],
  fetcher(
    request: References.GetByIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getAppByComponentKey
 */
export const GET_APP_BY_COMPONENT_KEY_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getAppByComponentKey';
export const GET_APP_BY_COMPONENT_KEY_QUERY: RegisteredQuery<
  'result',
  References.GetAppByComponentKeyRequestType,
  References.GetAppByComponentKeyResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_BY_COMPONENT_KEY_QUERY_FIELD_NAME,
  args: [
    'projectName',
    'developerSymbol',
    'revisionId',
    'applicationRequestExtras',
  ],
  fetcher(
    request: References.GetAppByComponentKeyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppByComponentKeyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppByComponentKeyRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getByIds
 */
export const GET_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getByIds';
export const GET_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetByIdsRequestType,
  References.GetByIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_IDS_QUERY_FIELD_NAME,
  args: ['appIds', 'applicationRequestExtras'],
  fetcher(
    request: References.GetByIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByIdsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getAiConnectorCatalog
 */
export const GET_AI_CONNECTOR_CATALOG_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getAiConnectorCatalog';
export const GET_AI_CONNECTOR_CATALOG_QUERY: RegisteredQuery<
  'result',
  References.GetAiConnectorCatalogRequestType,
  References.GetAiConnectorCatalogResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AI_CONNECTOR_CATALOG_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(
    request: References.GetAiConnectorCatalogRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAiConnectorCatalogResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAiConnectorCatalogRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc#getLocalisedAppPermissions
 */
export const GET_LOCALISED_APP_PERMISSIONS_QUERY_FIELD_NAME =
  'com_hubspot_applications_rpc_ApplicationsRpc_getLocalisedAppPermissions';
export const GET_LOCALISED_APP_PERMISSIONS_QUERY: RegisteredQuery<
  'result',
  References.GetLocalisedAppPermissionsRequestType,
  References.GetLocalisedAppPermissionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LOCALISED_APP_PERMISSIONS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetLocalisedAppPermissionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetLocalisedAppPermissionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getLocalisedAppPermissionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
